/* eslint-disable no-unused-vars */
import axiosAuthenticated, { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = () => ({
  blogs: [],
  singleBlog: {},
  blogsPageLoading: false
})

const getters = {
  blogs: (state) => state.blogs,
  singleBlog: (state) => state.singleBlog,
  blogsPageLoading: (state) => state.blogsPageLoading
}

const mutations = {
  SET_SINGLE_BLOG(state, payload) {
    state.singleBlog = payload
  },
  SET_BLOGS_PAGE_LOADING(state, payload) {
    state.blogsPageLoading = payload
  }
}

const actions = {
  fetchBlogsBlogsPage({ commit }, { vm }) {
    commit('SET_BLOGS_PAGE_LOADING', true)
    axiosApiInstance
      .get(vm.apiUrl)
      .then((res) => {
        const data = res.data

        vm.blogs = data.data
        vm.currentPage = data.current_page
        vm.perPage = data.per_page
        vm.numberOfPages = data.last_page
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('SET_BLOGS_PAGE_LOADING', false)
        }, 500)
      })
  },

  fetchSingleBlog({ commit }, { id }) {
    commit('SET_BLOGS_PAGE_LOADING', true)
    axiosApiInstance
      .get(`${urlBase}/single_blog`, {
        params: {
          id
        }
      })
      .then((res) => {
        commit('SET_SINGLE_BLOG', res.data)
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('SET_BLOGS_PAGE_LOADING', false)
        }, 500)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
